import mock from './mock';
import './db/profile-db';
import './db/icons-db';
import './db/auth-db';
import './db/providers-db';

mock.onAny().passThrough();
